module.exports = "/build/web/images/hero-home.7d939f8db5bb7407a0727d692ac0db15.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/hero-home.jpg
// module id = 120
// module chunks = 13